import { gql } from "@stadium/services/apollo-client";
import { PRODUCT_OPTION_TYPES_SERVER } from "@graphql/fragments/product/server/option-types";

export const PRODUCT_OPTION_TYPES = gql`
  ${PRODUCT_OPTION_TYPES_SERVER}
`;
